import { render } from "./ContactUsPage.vue?vue&type=template&id=5e127e90"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__